import __regexp from './__vivaldi-regexp';
/** Detect Vivaldi Browser */
export default function isVivaldi(ua) {
	return __regexp.test(ua);
}
